import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Profile from "./pages/Profile";
import MonarchIDE from "./pages/MonarchIDE";
import VideoHub from "./pages/VideoHub";
import InterviewSimulator from "./pages/InterviewSimulator";
import EmployerAssessmentHub from "./pages/EmployerAssessmentHub";

import MultiplayerQuiz from "./components/MultiplayerQuiz";
import ErrorBoundary from "./components/ErrorBoundary";
import GlobalAuthEnforcer from "./components/auth/GlobalAuthEnforcer";
import TeacherRegisterPage from "./components/auth/TeacherRegisterPage";
import { ScrollToTop } from "./components/layout/ScrollToTop";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <GlobalAuthEnforcer />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/presentations" element={<Navigate to="/" replace />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/multiplayer-quiz" element={<MultiplayerQuiz />} />
            <Route path="/register/teacher" element={<TeacherRegisterPage />} />
            <Route path="/ide" element={<MonarchIDE />} />
            <Route path="/videohub" element={<VideoHub />} />
            
            <Route path="/interview" element={<InterviewSimulator />} />
            <Route path="/assessment" element={<EmployerAssessmentHub />} />
            <Route path="/employer" element={<EmployerAssessmentHub />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
